import { render, staticRenderFns } from "./ShopPaymentModal.vue?vue&type=template&id=487479ae&scoped=true&"
import script from "./ShopPaymentModal.vue?vue&type=script&lang=js&"
export * from "./ShopPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopPaymentModal.vue?vue&type=style&index=0&id=487479ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487479ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDialog,VIcon,VSwitch,VTextField,VTooltip})
